import React, { Component } from "react"
import styled from "styled-components"
import ReactTable from "react-table"
import "react-table/react-table.css"
import "./mpu.css"
import { connect } from "react-redux"

const TextCollum = styled.div`
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
`

const TotalDataLength = styled.p`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 1rem;
  border: 1px solid #6e8ca0;
  padding: 8px 10px;
  border-radius: 5px;
  width: max-content;
`

const StyledButton = styled.button`
  background-color: #6e8ca0;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  outline: none;

  &:hover {
    background-color: #6e8ca0;
    outline: none;
    border: none;
  }
`

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`

const ContainerButton = styled.div`
  display: flex;
  gap: 10px;
`

const ResetButton = styled.button`
  background-color: #6e8ca0;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  outline: none;

  &:hover {
    background-color: #6e8ca0;
    outline: none;
    border: none;
  }
`

class MonthlyPayingUsersTable extends Component {
  state = {
    year: null,
    week: null,
    data: this.props.dataRetentionList,
    numCols: 25,
  }
  componentDidMount() {
    this.props.FaceserRetention(this.state.numCols)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.numCols !== this.state.numCols) {
      this.props.FaceserRetention(this.state.numCols)
    }
  }

  handleChange = (selectedOption, key) => {
    this.setState({ [key]: selectedOption })
  }

  addColumns = () => {
    this.setState((prevState) => ({
      numCols: prevState.numCols + 12,
    }))
  }

  resetColumns = () => {
    this.setState({
      numCols: 25,
    })
  }

  render() {
    const columns = [
      {
        Header: () => <TextCollum>Month and Year</TextCollum>,
        accessor: "monthYear",
        Cell: (row) => <div>{row.original.monthYear}</div>,
      },
      {
        Header: () => <TextCollum>MPU</TextCollum>,
        accessor: "mpu",
        Cell: (row) => <div>{row.original.mpu}</div>,
      },
    ]

    const monthlyPayingUsersData = Array.isArray(this.props.dataRetentionList)
    ? this.props.dataRetentionList
        .map((item) => ({
          monthYear: item.date,
          mpu: item.total_user,
        }))
        .sort((a, b) => new Date(b.monthYear) - new Date(a.monthYear)) 
    : [];

    const totalMPU = this.props.totalMPU || 0

    return (
      <div className="mpu">
        <HeaderContent>
          <TotalDataLength>Total MPU : {totalMPU}</TotalDataLength>
          <ContainerButton>
            {this.state.numCols > 25 && (
              <ResetButton onClick={this.resetColumns}>Reset</ResetButton>
            )}
            <StyledButton onClick={this.addColumns}>Load More</StyledButton>
          </ContainerButton>
        </HeaderContent>
        {monthlyPayingUsersData.length === 0 ? (
          <div style={{ padding: 20, textAlign: "center" }}>Loading or no data found</div>
        ) : (
          <ReactTable
            data={monthlyPayingUsersData}
            columns={columns}
            pageSize={monthlyPayingUsersData.length}
            showPagination={false}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapState = (state) => {
  return {
    dataRetentionList: state.dashoard.dataRetentionList,
    totalMPU: state.dashoard.totalMPU,
  }
}

const mapDispatch = (dispatch) => {
  return {
    FaceserRetention: (numCols) => dispatch.dashoard.FaceserRetention(numCols),
  }
}

export default connect(mapState, mapDispatch)(MonthlyPayingUsersTable)
